import React from 'react';

/**
 * Utilities component
 *
 *  - SVG linear gradients for yellow, rose and white gold
 */

export default class UtilsComponent extends React.Component {
    render() {
        return (
            <>
                <svg style={{width: 0, height: 0, position: 'absolute'}} aria-hidden="true" focusable="false">
                    <defs>
                        <filter id="shadow" x="-20%" y="-20%" width="200%" height="200%">
                            <feDropShadow dx="0" dy="5" stdDeviation="5" floodColor="#11153c" />
                        </filter>
                    </defs>
                    <defs>
                        <filter id="up-shadow" x="-20%" y="-20%" width="200%" height="200%">
                            <feDropShadow dx="0" dy="-5" stdDeviation="5" floodColor="#11153c" />
                        </filter>
                    </defs>
                </svg>

                <svg style={{width: 0, height: 0, position: 'absolute'}} aria-hidden="true" focusable="false">
                    <linearGradient id="yellow-gold-gradient" x1="0%" y1="0%" x2="0%" y2="100%" gradientTransform="rotate(0)">
                        <stop offset="0%" stopColor="#c3a87b" />
                        <stop offset="3%" stopColor="#b3935d" />
                        <stop offset="33%" stopColor="#d9cba7" />
                        <stop offset="40%" stopColor="#d0b378" />
                        <stop offset="70%" stopColor="#c9b285" />
                        <stop offset="96%" stopColor="#a48a59" />
                        <stop offset="100%" stopColor="#bfac88" />
                    </linearGradient>
                </svg>

                <svg style={{width: 0, height: 0, position: 'absolute'}} aria-hidden="true" focusable="false">
                    <linearGradient id="rose-gold-gradient" x1="0%" y1="0%" x2="0%" y2="100%" gradientTransform="rotate(0)">
                        <stop offset="0%" stopColor="#b89075" />
                        <stop offset="3%" stopColor="#df896b" />
                        <stop offset="33%" stopColor="#edc6ba" />
                        <stop offset="38%" stopColor="#d48063" />
                        <stop offset="70%" stopColor="#cb8066" />
                        <stop offset="96%" stopColor="#b46654" />
                        <stop offset="100%" stopColor="#e38673" />
                    </linearGradient>
                </svg>

                <svg style={{width: 0, height: 0, position: 'absolute'}} aria-hidden="true" focusable="false">
                    <linearGradient id="white-gold-gradient" x1="0%" y1="0%" x2="0%" y2="100%" gradientTransform="rotate(0)">
                        <stop offset="0%" stopColor="#e9e8e6" />
                        <stop offset="3%" stopColor="#c9c8c5" />
                        <stop offset="33%" stopColor="#f2f2f2" />
                        <stop offset="40%" stopColor="#c5c4c3" />
                        <stop offset="70%" stopColor="#d2d2d1" />
                        <stop offset="96%" stopColor="#a6a39f" />
                        <stop offset="100%" stopColor="#dedede" />
                    </linearGradient>
                </svg>
            </>
        );
    }
}
